import { loginSDK, SDK_ENV, type Channels, initRemoteLoginSDK } from '@eureka/shared/src/login-sdk';
import type { I18n } from 'vue-i18n';
import { SLD, Site, DeployEnv } from '@patsnap-utils/biz';

/**
 * 初始化登录 SDK（纯 TS 工具函数，不依赖 Vue）
 * @param i18n - i18n 实例
 * @param channels - 渠道参数
 * @returns openLoginDialog 方法
 */
export function _initLoginSdk(i18n: I18n, channels: Channels = {}) {
    // 根据环境变量判断区域
    const region = localStorage.getItem('mock_login_region') || new Site({ sld: SLD.EUREKA }).env || 'CN';
    console.log(`Login Region: ${region}`); // 输出当前环境区域，帮助调试登录 SDK 行为
    const sdkEnv = [DeployEnv.US, DeployEnv.EU].includes(region) ? SDK_ENV.US : SDK_ENV.CN;

    loginSDK.setI18n(i18n).setEnv(sdkEnv).setChannels(channels);

    /**
     * 打开登录对话框
     * @param withoutClose - 是否禁用关闭按钮（默认 true）
     * @param customChannels - 自定义渠道参数（可选，用于覆盖初始化时的 channels）
     * @returns Promise - 登录成功且应用重新初始化完成后 resolve
     */
    const openLoginDialog = async (withoutClose = true, customChannels?: Channels): Promise<void> => {
        // 如果传入了自定义 channels，临时更新
        if (customChannels) {
            loginSDK.setChannels(customChannels);
        }

        // 1. 打开登录对话框，等待用户登录成功
        await loginSDK.open({ withoutClose });

        // 2. 登录成功后重新初始化应用数据
        if (window.__reinitializeApp) {
            await window.__reinitializeApp();
        } else {
            // 降级方案：如果全局函数不存在，还是刷新页面

            window.location.reload();
        }

        // 3. 到这里说明登录成功且 reinit 完成
    };

    const handleThirdPartyLoginErrors = () => {
        loginSDK.handleThirdPartyLoginErrors();
    };

    return { openLoginDialog, handleThirdPartyLoginErrors };
}


export function initLoginSdk(i18n: I18n, channels: Channels = {}) {
    const openLoginDialog = async () => {
        const { openLoginDialog } = await initRemoteLoginSDK();

        await openLoginDialog({
            channels,
        });

        if (window.__reinitializeApp) {
            await window.__reinitializeApp();
        } else {
            window.location.reload();
        }
    };

    const handleThirdPartyLoginErrors = () => {
        initRemoteLoginSDK()
            .then(({ initSDK }) => {
                initSDK();
            });
    };

    return {
        openLoginDialog,
        handleThirdPartyLoginErrors,
    };
}
